module.exports = __webpack_public_path__ + "img/Villa_Borna_21.968da6ed.jpg";